import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./PrivacySupplement.module.css";
import { FaArrowLeft } from "react-icons/fa6";
import { LanguageContext } from "./LanguageContext";
import LanguageSelector from "./LanguageSelector";

import privacyEnglish from "../utils/languages/privacy/eng.json";
import privacySwahili from "../utils/languages/privacy/sw.json";
import privacyFrench from "../utils/languages/privacy/fr.json";

const languageMap = {
  eng: privacyEnglish,
  sw: privacySwahili,
  fr: privacyFrench,
};

const PrivacySupplement = () => {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    const mapped = languageMap[lang] || languageMap.eng;
    setData(mapped?.privacySupplement || {});
  }, [lang]);

  const handleBack = () => {
    navigate("/register", { replace: true });
  };

  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <div className={classes.topBar_back_btn}>
          <button onClick={handleBack} className={classes.back_btn}>
            <FaArrowLeft className={classes.back_icon} />
          </button>
          <LanguageSelector />
        </div>

        <h1 className={classes.title}>{data?.title}</h1>

        <div className={classes.contentBox}>
          <p>{data?.intro?.[0]}</p>
          <p>{data?.intro?.[1]}</p>
          <p>{data?.intro?.[2]}</p>
          <p>{data?.intro?.[3]}</p>
          <p>{data?.intro?.[4]}</p>
          <p>{data?.intro?.[5]}</p>

          <h3>
            {data?.sections?.[0]?.id}. {data?.sections?.[0]?.heading}
          </h3>
          <p>{data?.sections?.[0]?.content?.[0]}</p>
          <p>• {data?.sections?.[0]?.items?.[0]}</p>
          <p>• {data?.sections?.[0]?.items?.[1]}</p>
          <p>• {data?.sections?.[0]?.items?.[2]}</p>
          <p>• {data?.sections?.[0]?.items?.[3]}</p>
          <p>• {data?.sections?.[0]?.items?.[4]}</p>
          <p>• {data?.sections?.[0]?.items?.[5]}</p>

          <h3>
            {data?.sections?.[1]?.id}. {data?.sections?.[1]?.heading}
          </h3>
          <p>{data?.sections?.[1]?.content?.[0]}</p>
          <p>{data?.sections?.[1]?.content?.[1]}</p>
          <p>{data?.sections?.[1]?.content?.[2]}</p>
          <p>{data?.sections?.[1]?.content?.[3]}</p>
          <p>{data?.sections?.[1]?.content?.[4]}</p>
          <p>{data?.sections?.[1]?.content?.[5]}</p>
          <p>{data?.sections?.[1]?.content?.[6]}</p>
          <p>{data?.sections?.[1]?.content?.[7]}</p>
          <p>{data?.sections?.[1]?.content?.[8]}</p>
          <p>{data?.sections?.[1]?.content?.[9]}</p>
          <p>{data?.sections?.[1]?.content?.[10]}</p>

          <h3>
            {data?.sections?.[2]?.id}. {data?.sections?.[2]?.heading}
          </h3>
          <p>{data?.sections?.[2]?.content?.[0]}</p>
          <p>• {data?.sections?.[2]?.items?.[0]}</p>
          <p>• {data?.sections?.[2]?.items?.[1]}</p>
          <p>• {data?.sections?.[2]?.items?.[2]}</p>
          <p>• {data?.sections?.[2]?.items?.[3]}</p>
          <p>• {data?.sections?.[2]?.items?.[4]}</p>
          <p>• {data?.sections?.[2]?.items?.[5]}</p>
          <p>{data?.sections?.[2]?.footer?.[0]}</p>
          <p>{data?.sections?.[2]?.footer?.[1]}</p>

          <h3>
            {data?.sections?.[3]?.id}. {data?.sections?.[3]?.heading}
          </h3>
          <p>{data?.sections?.[3]?.content?.[0]}</p>
          <p>{data?.sections?.[3]?.content?.[1]}</p>
          <p>{data?.sections?.[3]?.content?.[2]}</p>
          <p>{data?.sections?.[3]?.content?.[3]}</p>
          <p>{data?.sections?.[3]?.content?.[4]}</p>
          <p>{data?.sections?.[3]?.content?.[5]}</p>
          <p>{data?.sections?.[3]?.content?.[6]}</p>

          <h3>
            {data?.sections?.[4]?.id}. {data?.sections?.[4]?.heading}
          </h3>
          <p>{data?.sections?.[4]?.content?.[0]}</p>
          <p>{data?.sections?.[4]?.content?.[1]}</p>
          <p>{data?.sections?.[4]?.content?.[2]}</p>
          <p>{data?.sections?.[4]?.content?.[3]}</p>

          <h3>
            {data?.sections?.[5]?.id}. {data?.sections?.[5]?.heading}
          </h3>
          <p>{data?.sections?.[5]?.content?.[0]}</p>
          <p>{data?.sections?.[5]?.content?.[1]}</p>
          <p>{data?.sections?.[5]?.content?.[2]}</p>
          <p>{data?.sections?.[5]?.content?.[3]}</p>
          <p>{data?.sections?.[5]?.content?.[4]}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacySupplement;
